export default "__VITE_ASSET__mYFKgAnFZlzdosq$lJ_SUw__"